import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { SmaPortalService } from '../../../services/toolbar-portal.service';

@Component({
  selector: 'sma-page-toolbar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-toolbar.component.html',
  styleUrl: './page-toolbar.component.less',
})
export class PageToolbarComponent {
  private readonly _portalService = inject(SmaPortalService);

  @ViewChild('toolbarPortal', { read: ElementRef, static: false })
  set toolbarPortal(el: ElementRef) {
    if (el) {
      this._portalService.setHostPortal(el);
    }
  }
}
